module.exports = __webpack_public_path__ + "img/Image_logo_14.88ff6c8d.jpg";